import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <MediaSection />
        <ContactSection />
        <CarouselSection />
        <CommentsSection />
        <TopicsSection />
        <AppSection />
        <AboutSection />
        <UpdatesSection />
        <FeaturesSection />
        <CardsSection />
        <FAQSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}